// import React from 'react';
// import { Route, Redirect } from 'react-router-dom';

// const hasAuthenticity = sessionStorage.getItem('data');

// export const PrivateRoute = ({ component: Component, ...rest }) => (
//   <Route {...rest} render={props => (
//     hasAuthenticity
//     ? <Component {...props} />
//     : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
//   )} />
// );

// import React from "react";
// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children, requiredPermission }) => {
//   const hasAuthenticity = sessionStorage.getItem("auth");

//   if (!hasAuthenticity) {
//     return <Navigate to="/" replace />;
//   }

//   if (requiredPermission) {
//     const dataString = sessionStorage.getItem("data");
//     let hasPermission = false;

//     if (dataString) {
//       try {
//         const data = JSON.parse(dataString);
//         const loginData = data?.menuVisiblity || [];

//         // Check if the user has the required permission in the main menu list
//         hasPermission = loginData.some(
//           (menu) => menu.name === requiredPermission && menu.isVisible,
//         );
//       } catch (error) {
//         console.error("Error parsing session data for permissions", error);
//       }
//     }

//     if (!hasPermission) {
//       console.warn(`Access denied: requires ${requiredPermission}`);
//       return <Navigate to="/" replace />;
//     }
//   }

//   return children;
// };

// export default PrivateRoute;

import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({
  children,
  requiredPermission,
  requiredRole,
}) => {
  const hasAuthenticity = sessionStorage.getItem("auth");

  // Not logged in
  if (!hasAuthenticity) {
    return <Navigate to="/" replace />;
  }

  const dataString = sessionStorage.getItem("data");

  let loginData = {};
  let menuVisibility = [];

  if (dataString) {
    try {
      loginData = JSON.parse(dataString);
      menuVisibility = loginData?.menuVisiblity || [];
    } catch (error) {
      console.error("Error parsing session data:", error);
    }
  }

  // Check role if required
  if (requiredRole) {
    const userRole = loginData?.userType
      ? loginData.userType.trim().toUpperCase()
      : "";

    if (userRole !== requiredRole.toUpperCase()) {
      console.warn(`Access denied: requires role ${requiredRole}`);
      return <Navigate to="/" replace />;
    }
  }

  // Check permission if required
  if (requiredPermission) {
    const hasPermission = menuVisibility.some(
      (menu) =>
        menu.name === requiredPermission &&
        menu.isVisible
    );

    if (!hasPermission) {
      console.warn(
        `Access denied: requires ${requiredPermission}`
      );

      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default PrivateRoute;


